// extracted by mini-css-extract-plugin
module.exports = {"wrap":"hr-z","title":"ir-z","cta":"jr-z","disabled":"kr-z"};